module.exports = __webpack_public_path__ + "static/media/icon-award-01.f501774e.svg";